import { render, staticRenderFns } from "./NsCard.vue?vue&type=template&id=59f4c977&scoped=true&"
import script from "./NsCard.vue?vue&type=script&lang=js&"
export * from "./NsCard.vue?vue&type=script&lang=js&"
import style0 from "./NsCard.vue?vue&type=style&index=0&id=59f4c977&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4c977",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f4c977')) {
      api.createRecord('59f4c977', component.options)
    } else {
      api.reload('59f4c977', component.options)
    }
    module.hot.accept("./NsCard.vue?vue&type=template&id=59f4c977&scoped=true&", function () {
      api.rerender('59f4c977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsCard.vue"
export default component.exports